import { useState, useEffect } from "react";
import { ScreenWidth } from "css/Media";
import debounce from "lodash.debounce";

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkScreenSize = () => {
      let mobile = false;
      if (ScreenWidth.lessThan("s")) {
        mobile = true;
      }
      setIsMobile(mobile);
    };
    checkScreenSize();
    window.addEventListener(
      "resize",
      debounce(() => checkScreenSize()),
      500
    );
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  return isMobile;
}

export default useIsMobile;
